import { Banner } from '@astryxdesign/core/Banner';

/** Preview studios show a visible "sample" notice: no real notifications go out. */
export function PreviewBanner() {
  return (
    <Banner
      status="info"
      container="section"
      title="Образец страницы"
      description="Студия ещё не запущена: записи демонстрационные, уведомления не отправляются."
    />
  );
}
